import { handleAuthentikCallback } from "./components/Login/authentik";
import { useState, useEffect, useRef } from 'react';
import AuthContext from './AuthContext'
import { Application } from './core/app';
import { getMe } from './api/backend';

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const hasLoadedUser = useRef(false);

    // Listen for external auth state changes (e.g., from bootstrap.js 401 handler)
    useEffect(() => {
        const handleAuthChange = (event) => {
            if (event.detail === 'logout') {
                setUser(null);
            }
        };
        window.addEventListener('authstatechange', handleAuthChange);
        return () => window.removeEventListener('authstatechange', handleAuthChange);
    }, []);

    const loadCurrentUser = () => {
        if (hasLoadedUser.current) return;
        hasLoadedUser.current = true;

        getMe().then((res) => {
            const me = res.data;
            if (me) {
                Application.setAuthUserData(me);
                setUser({
                    provider: 'authentik',
                    uid: 'authentik-user',
                    displayName: me.name || '',
                    email: me.email || '',
                });
            } else {
                setUser({ provider: 'authentik', uid: 'authentik-user' });
            }
        }).catch(() => {
            setUser({ provider: 'authentik', uid: 'authentik-user' });
        });
    };

    useEffect(() => {
        // First, check if we have an Authentik callback in the URL
        const hasAuthentikCallback = handleAuthentikCallback();
        
        if (hasAuthentikCallback) {
            const token = Application.getAccessToken();
            if (token) {
                Application.setAuthProvider('authentik');
                window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                window.axios.defaults.headers.common['accessToken'] = token;
                loadCurrentUser();
            }
            setLoading(false);
            return;
        }

        // Check for existing Authentik token in localStorage
        const authentikToken = localStorage.getItem('authentik_token');
        if (authentikToken) {
            Application.setAccessToken(authentikToken);
            Application.setAuthProvider('authentik');
            window.axios.defaults.headers.common['Authorization'] = `Bearer ${authentikToken}`;
            window.axios.defaults.headers.common['accessToken'] = authentikToken;
            loadCurrentUser();
            setLoading(false);
            return;
        }

        // Check if we're on the login page and there's no valid auth — stay logged out
        if (window.location.pathname === '/login' && !user) {
            setLoading(false);
            return;
        }

        setLoading(false);
    }, []);

    return (
        <AuthContext.Provider value={{ user, loading }}>
            {loading ? (
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '100vh',
                    backgroundColor: '#121212',
                    color: 'white'
                }}>
                    Loading...
                </div>
            ) : (
                children
            )}
        </AuthContext.Provider>
    );
};
